export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("apollo:error", (error) => {

    if (process.client) {
      const tokenCookie = useCookie("apollo:favorites.token");
      const hadToken = !!tokenCookie.value;
      tokenCookie.value = null;

      if (hadToken) {
        refreshNuxtData();
      }
    }
  });
});
